import api from "../api";

const order = {
  getAll() {
    return new Promise((resolve, reject) => {
      api.get(
        `/orders/`,
        data => resolve(data),
        error => reject(error)
      );
    });
  },
  getOne(orderId) {
    return new Promise((resolve, reject) => {
      api.get(
        `/orders/${orderId}`,
        data => resolve(data),
        error => reject(error)
      );
    });
  },
  getItems(orderId) {
    return new Promise((resolve, reject) => {
      api.get(
        `/orders/${orderId}/items`,
        data => resolve(data),
        error => reject(error)
      );
    });
  },
  getAnItem(orderId, orderItemId) {
    return new Promise((resolve, reject) => {
      api.get(
        `/orders/${orderId}/items/${orderItemId}`,
        data => resolve(data),
        error => reject(error)
      );
    });
  },
  place(content) {
    return new Promise((resolve, reject) => {
      api.post(
        `/orders/`,
        content,
        data => resolve(data),
        error => reject(error)
      );
    });
  },
}

export default order;